import { bool, string, oneOfType, object } from 'prop-types';
import React from 'react';
import AccountIcon from 'dibs-vg/dist/react/account-outlined';
import MaskIcon from 'dibs-vg/dist/react/mask';
import { trackEvent } from 'dibs-tracking';

import styles from './AccountNavTrigger-style.scss';

const AccountNavTrigger = ({ isMasquerading, isVerifiedTrade, name }) => {
    return (
        <div data-tn="user-menu-logged-in" className={styles.accountWrapper}>
            <a data-tn="user-menu-logged-in-name" className={styles.name}>
                {isMasquerading ? (
                    <span data-tn="user-menu-masq-icon" className={styles.maskIcon}>
                        <MaskIcon />
                    </span>
                ) : null}
                {isMasquerading ? <span>({name})</span> : name}
            </a>
            <a
                className={styles.accountIcon}
                href={isVerifiedTrade ? '/trade/workspace/' : '/my/account/'}
                onClick={() => {
                    trackEvent({
                        category: 'navigation',
                        action: 'header navigation click',
                        label: 'user-nav|user icon',
                    });
                }}
            >
                <AccountIcon />
            </a>
        </div>
    );
};

AccountNavTrigger.propTypes = {
    isMasquerading: bool,
    isVerifiedTrade: bool,
    name: oneOfType([string, object]),
};

export default AccountNavTrigger;
